import styled from '@emotion/styled';
import React from 'react';

const StyledFormPreviewCardContainer = styled.div<{
  selected: boolean;
}>`
  background: var(--deprecated-neutral-100);
  border: 1px solid var(--deprecated-neutral-200);
  border-radius: 8px;
  height: 261px;
  max-width: 400px;
  box-sizing: border-box;
  box-shadow: var(--elevation-surface-raised);
  cursor: pointer;

  ${(props) => props.selected && 'border: 1px solid var(--primary-400);'}
`;

const StyledFormPreviewCardHeader = styled.div`
  position: relative;
  display: flex;
  background: var(--deprecated-neutral-50);
  justify-content: center;
  align-items: center;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  width: 100%;
  height: 186px;
  overflow: hidden;
`;

const StyledFormPreviewCardHeaderOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
`;

const StyledFormPreviewCardIcon = styled.div`
  position: absolute;
  top: 50%;
  right: 0;
  transform: translate(-50%, -50%);
  display: grid;
  place-items: center;
  padding: 5px;
  border-radius: 4px;
  opacity: 0;
  color: var(--deprecated-neutral-600);
  &[data-state-open='true'] {
    opacity: 1;
    background-color: var(--deprecated-neutral-200);
    [data-theme='dark'] & {
      background-color: var(--deprecated-neutral-200);
    }
  }

  :hover {
    background-color: var(--deprecated-neutral-200);
  }

  [data-theme='dark'] & {
    color: var(--deprecated-neutral-800);

    :hover {
      background-color: var(--deprecated-neutral-700);
    }
  }
`;

const StyledFormContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  position: relative;
  border-top: 1px solid var(--deprecated-neutral-200);
  height: 75px;
  width: 100%;
  background-color: var(--foreground);
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  padding: 0px 18px;
  overflow: hidden;
  white-space: nowrap;

  &:hover ${StyledFormPreviewCardIcon} {
    opacity: 1;
  }
`;

const StyledFormContentRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  overflow: hidden;
  white-space: nowrap;
  max-width: 100%;
`;

function FormPreviewCardHeader({ children }: React.PropsWithChildren<unknown>): JSX.Element {
  return (
    <StyledFormPreviewCardHeader>
      {children}
      <StyledFormPreviewCardHeaderOverlay />
    </StyledFormPreviewCardHeader>
  );
}

export {
  StyledFormPreviewCardContainer,
  StyledFormContent,
  StyledFormPreviewCardIcon,
  FormPreviewCardHeader,
  StyledFormContentRow,
};
